import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '=',
        disabled: '<'
    },
    template: `
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <textarea
            ng-model="vm.form.answers[vm.question.id].answerText"
            ng-keyup="vm.change()"
            class="form-control"
            ng-disabled="vm.disabled"
        ></textarea>
    `
})
export default class {
    constructor (lodash, QuestionService) {
        this.submittedAnswerId = lodash.get(this.question, 'submittedAnswer.id', null);
        this.submittedAnswerText = lodash.get(this.question, 'submittedAnswer.answerText', null);
        this.answer = {
            id: this.submittedAnswerId,
            questionId: this.question.id,
            language: this.form.language,
            answerText: this.submittedAnswerText
        };

        this.form.answers[this.question.id] = this.answer;
        this.answered = false;
        this.QuestionService = QuestionService;
    }

    $onInit () {
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;
        if (this.submittedAnswerId && this.submittedAnswerText) {
            this.answeredQuestions = this.answeredQuestions + 1;
        }
    }

    change () {
        if (this.form.answers[this.question.id].answerText && !this.answered) {
            this.answeredQuestions = this.answeredQuestions + 1;
            this.answered = true;
        }
        else if (this.answered && !this.form.answers[this.question.id].answerText) {
            this.answeredQuestions = this.answeredQuestions - 1;
            this.answered = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/question/freeText/index.js